import { usePostHog } from 'posthog-js/react';
import { MouseEvent } from 'react';
import { useAnalytics } from 'use-analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { OAUTH_TRACKING_KEY } from './useSocialRegister.hook';

export const useSocialLogin = () => {
  const { track } = useAnalytics();
  const postHog = usePostHog();

  const handleSocialLogin = (
    event: MouseEvent<HTMLButtonElement>,
    provider: string,
    link: string,
  ): void => {
    event.preventDefault();

    // Store variant in localStorage before OAuth redirect for tracking after success
    const backgroundVariant = postHog.getFeatureFlag(PostHogFeatureFlagEnum.SignupBackgroundTest);
    localStorage.setItem(
      OAUTH_TRACKING_KEY,
      JSON.stringify({
        variant: backgroundVariant,
        provider: provider.toLowerCase(),
        timestamp: Date.now(),
      }),
    );

    track(
      `login_${provider}_click`,
      { event_category: 'User login', event_label: 'login_form' },
      () => {
        window.location.href = link;
      },
    );
  };

  return {
    handleSocialLogin,
  };
};
